import { MortgageInterface } from '@app/interfaces/mortgage.interface';

export class FillingScore250 {
    static check(mortgage: MortgageInterface): boolean {
        return !!(mortgage.amount && mortgage.maturity && mortgage.purposes && mortgage.purposes.length > 0);
    }
}
